__turbopack_context__.v({
  "cookie": "CookieAgreements-module__oA_w6q__cookie",
  "cookie-content": "CookieAgreements-module__oA_w6q__cookie-content",
  "link": "CookieAgreements-module__oA_w6q__link",
});
